'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotTernaryContourIcon = function PlotTernaryContourIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M30.375 28.688L16 1.188 3.625 24.813l-2 3.875zM4.688 25.75c.375-.313 1.188-.688 2-.563.375 0 .625.25.938.563.375.625 1.188 1.188 2.125 1.563h-6zm14.125 1.563s.125 0 .25-.125c2.25-1.313 4.813-2.625 7.188-3.563l2 3.688zm-7.188-14.5c.5-.563 1.813-.688 3.438-.688s3.313.125 4.563.438l3.313 5.438c-1.875.125-3.625 0-5.5 0-3.563-.125-6-2.125-6-4.688-.125-.125 0-.25.188-.5zm5.688 6.5c1.063 0 2.313.125 3.375.125h2c-1.5 1.875-4.938 5.5-9.063 4-2.188-.875-4.188-2-5.875-3.438l2.625-4.938c.688 2.375 3.375 4.125 6.938 4.25zm2.437-8c-1.188-.125-5.063-.625-7.5-.125L16 4.125zm-12.687 9.75c1.875 1.5 3.875 2.563 6.125 3.5.813.25 1.625.375 2.438.375 4.25 0 7.438-3.875 8.625-5.5l1.5 2.813c-2.563 1.063-4.938 2.313-7.375 3.75-3.438 2-8.625.563-9.688-1.188a2.572 2.572 0 0 0-1.75-1.188H5.75z' })
    );
};

exports.default = PlotTernaryContourIcon;